<template>
  <div
    :class="[
      $style.base,
      {
        [$style.disabled]: !!action.disabled
      }
    ]"
  >
    <component
      :is="action.routerLink ? 'router-link' : action.href ? 'a' : 'div'"
      :to="action.routerLink ? action.routerLink : null"
      :href="action.href || null"
      :target="action.href ? '_blank' : null"
      :class="$style.inner"
      @click="$emit('click')"
      v-test="`modal-action-${action.name}`"
    >
      <BaseIcon
        v-if="action.icon"
        :name="action.icon"
      />
      <div :class="$style.label">{{ action.label }}</div>
    </component>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  inheritAttrs: false,
  props: ['action'],
  emits: ['click'],
});
</script>

<style
  lang="scss"
  module
>
.base {
  &:not(:last-child) {
    border-bottom: 1px solid var(--border);
  }
}

.inner {
  display: flex;
  align-items: center;
  gap: $spacing * .5;
  padding: $spacing;
  cursor: pointer;
  background-color: var(--surface-primary);

  @include hover {
    background-color: var(--highlight);
  }

  &:active {
    background-color: var(--highlight-strong);
  }

  &:focus-visible {
    outline: none;
    background-color: var(--highlight);
  }

  .base.disabled & {
    @include input-disabled;
  }
}

.label {
  font-weight: bold;
}
</style>
